import { useContext } from 'react';

import { ExecuteActionContext } from 'components/lib/connect';

export function useExecuteAction() {
  return useContext(ExecuteActionContext);
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/hooks/connect_hooks.js